const CompareObject = ({ oldValues, newValues }) => {
  let valueChanged = false;

  if (!Object.keys(oldValues).length && !Object.keys(newValues).length) {
    return false;
  }

  Object.keys(oldValues)?.map((value) => {
    const oldItem = oldValues[value] || null;
    const newItem = newValues[value] || null;

    if (oldItem !== newItem) {
      valueChanged = true;
    }
  });

  return valueChanged;
};

export default CompareObject;
